import React from 'react';
import { CartLine } from '../newOrderTypes';
import styles from './ReviewStep.module.css';

interface ReviewStepProps {
  cart: CartLine[];
  customerName: string;
  setCart: React.Dispatch<React.SetStateAction<CartLine[]>>;
}

const formatCurrency = (n: number) => `$${n.toFixed(2)}`;

export const ReviewStep: React.FC<ReviewStepProps> = ({ cart, customerName, setCart }) => {
  const subtotal = cart.reduce((s, l) => s + l.product.rawPrice * l.qty, 0);
  const totalItems = cart.reduce((s, l) => s + l.qty, 0);

  const changeQty = (id: string, delta: number) => {
    setCart((prev) =>
      prev
        .map((l) => (l.product.id === id ? { ...l, qty: Math.max(0, l.qty + delta) } : l))
        .filter((l) => l.qty > 0)
    );
  };

  return (
    <div className={styles.wrap}>
      <h3 className={styles.title}>
        <span className={styles.titleIcon}>📋</span> Review Order
      </h3>
      <p className={styles.subtitle}>Verify items and quantities before confirming</p>

      <div className={styles.customerBanner}>
        <span className={styles.bannerIcon}>👤</span>
        <div>
          <p className={styles.bannerLabel}>Order for</p>
          <p className={styles.bannerName}>{customerName || '—'}</p>
        </div>
      </div>

      <div className={styles.items}>
        {cart.map((line) => (
          <div key={line.product.id} className={styles.item}>
            <div>
              <p className={styles.itemName}>{line.product.name}</p>
              <p className={styles.itemSub}>
                {line.product.price} · {line.qty}
              </p>
              <p className={styles.itemPrice}>{formatCurrency(line.product.rawPrice * line.qty)}</p>
            </div>
            <div className={styles.qtyControl}>
              <button onClick={() => changeQty(line.product.id, -1)}>-</button>
              <span className={styles.qtyValue}>{line.qty}</span>
              <button onClick={() => changeQty(line.product.id, 1)}>+</button>
            </div>
          </div>
        ))}
        {cart.length === 0 && (
          <p style={{ color: '#6B7280', fontSize: 14, padding: 12 }}>Cart is empty.</p>
        )}
      </div>

      <div className={styles.summary}>
        <h4 className={styles.summaryTitle}>Order Summary</h4>
        <div className={styles.summaryRow}>
          <span>Subtotal ({totalItems} items)</span>
          <span>{formatCurrency(subtotal)}</span>
        </div>
        <div className={styles.summaryRow}>
          <span>Estimated Margin</span>
          <span className={styles.green}>—</span>
        </div>
        <div className={styles.totalRow}>
          <span>Total Amount</span>
          <span className={styles.totalAmount}>{formatCurrency(subtotal)}</span>
        </div>
      </div>
    </div>
  );
};
